var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "sendDocumentsToLender",
    attrs: {
      id: "send-documents-to-lender-modal",
      "footer-close-button": false,
      "modal-dialog-size": "lg",
    },
    on: {
      hide: function ($event) {
        _vm.showHistoryTable = false
      },
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _vm._v(
              "\n    " + _vm._s(_vm.$t("documents.documentsList")) + "\n  "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c("p", [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t("documents.selectDocumentsToSend", {
                      lenderName: _vm.lenderName,
                    })
                  ) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            !_vm.isEmptyData
              ? _c(
                  "div",
                  [
                    _c("v-client-table", {
                      staticClass: "vue-custom-table no-pagination",
                      attrs: {
                        data: _vm.documentsToSend,
                        columns: _vm.table.columns,
                        options: _vm.table.options,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "h__selected",
                            fn: function () {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "form-group-checkbox" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "pretty p-icon p-jelly p-smooth p-curve mr-0",
                                      },
                                      [
                                        _c("input", {
                                          staticClass: "checkbox",
                                          attrs: {
                                            id: "select-all",
                                            type: "checkbox",
                                            "true-value": "true",
                                          },
                                          domProps: {
                                            checked:
                                              _vm.selectedDocsToSend.length ===
                                              _vm.documentsToSend.length,
                                          },
                                          on: { click: _vm.handleSelectAll },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "state p-success" },
                                          [
                                            _c("i", {
                                              staticClass: "icon fa fa-check",
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "label",
                                              {
                                                staticClass: "hidden-text",
                                                attrs: { for: "select-all" },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "global.actions.selectAll"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "selected",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                _c(
                                  "div",
                                  { staticClass: "form-group-checkbox" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "pretty p-icon p-jelly p-smooth p-curve mr-0",
                                      },
                                      [
                                        _c("input", {
                                          staticClass: "checkbox",
                                          attrs: {
                                            id:
                                              "select-recipient-" +
                                              row.documentId,
                                            type: "checkbox",
                                            "true-value": "true",
                                            name:
                                              "select-recipient-" +
                                              row.documentId,
                                          },
                                          domProps: {
                                            checked: _vm.documentIsSelected(
                                              row.documentId
                                            ),
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleSelectDocument(
                                                row.documentId
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "state p-success" },
                                          [
                                            _c("i", {
                                              staticClass: "icon fa fa-check",
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "label",
                                              {
                                                staticClass: "hidden-text",
                                                attrs: {
                                                  for:
                                                    "select-recipient-" +
                                                    row.documentId,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "global.words.select"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "classificationType",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                _c(
                                  "h6",
                                  {
                                    staticClass:
                                      "regular my-auto text-primary text-capitalize bold",
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(row.classificationType) +
                                        "\n          "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        137433715
                      ),
                    }),
                    _vm._v(" "),
                    _vm.submission.docMethod &&
                    _vm.submission.docMethod.toUpperCase() === "U"
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "d-flex flex-column align-items-center w-100 mt-3",
                          },
                          [
                            _c("p", [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "documents.lenderNotNotifiedUponSending"
                                    )
                                  ) +
                                  "\n        "
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isEmptyData &&
            _vm.documentsSentWithDetails.length > 0 &&
            !_vm.documentListEmpty
              ? _c(
                  "div",
                  {
                    staticClass: "d-flex flex-column align-items-center w-100",
                  },
                  [
                    _c(
                      "no-results",
                      {
                        attrs: {
                          "img-src": require("@Shared/@Assets/img/application-missing.png"),
                        },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("documents.allDocumentsSent")) +
                            "\n      "
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "b-button",
              {
                staticClass: "d-flex align-items-center",
                attrs: { variant: "primary" },
                on: {
                  click: function ($event) {
                    _vm.showHistoryTable = !_vm.showHistoryTable
                  },
                },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("documents.submissionHistory")) +
                    "\n      "
                ),
                _c("b-icon", {
                  staticClass: "ml-2",
                  attrs: {
                    icon: _vm.showHistoryTable
                      ? "caret-up-fill"
                      : "caret-down-fill",
                    "font-scale": "0.75",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("transition", { attrs: { name: "expand-fade" } }, [
              _vm.showHistoryTable
                ? _c(
                    "div",
                    [
                      _c("v-client-table", {
                        staticClass: "vue-custom-table no-pagination",
                        attrs: {
                          id: "documents-history-table",
                          data: _vm.documentsSentWithDetails,
                          columns: _vm.historyTable.columns,
                          options: _vm.historyTable.options,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "classification",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _c(
                                    "h6",
                                    {
                                      staticClass:
                                        "regular my-auto text-primary text-capitalize bold",
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(row.docType) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                            {
                              key: "insertionTimestamp",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _c("h6", { staticClass: "regular my-auto" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.formatDateHour(
                                            row.documentSentDate ||
                                              row.insertionTimestamp
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3167803671
                        ),
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("div", { staticClass: "row mb-4" }, [
              _c("div", { staticClass: "align-items-sm-start col d-flex" }, [
                _c(
                  "div",
                  {
                    staticClass: "pretty p-icon p-jelly p-smooth p-curve mt-2",
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.lenderDocSubmissionDisclaimerAccepted,
                          expression: "lenderDocSubmissionDisclaimerAccepted",
                        },
                      ],
                      staticClass: "form-check-input",
                      attrs: {
                        id: "lenderDocSubmissionDisclaimer",
                        type: "checkbox",
                      },
                      domProps: {
                        checked: Array.isArray(
                          _vm.lenderDocSubmissionDisclaimerAccepted
                        )
                          ? _vm._i(
                              _vm.lenderDocSubmissionDisclaimerAccepted,
                              null
                            ) > -1
                          : _vm.lenderDocSubmissionDisclaimerAccepted,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.lenderDocSubmissionDisclaimerAccepted,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.lenderDocSubmissionDisclaimerAccepted =
                                  $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.lenderDocSubmissionDisclaimerAccepted = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.lenderDocSubmissionDisclaimerAccepted = $$c
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "state p-primary" }, [
                      _c("i", { staticClass: "icon fa fa-check" }),
                      _vm._v(" "),
                      _c("label", {
                        staticClass: "hidden-text",
                        attrs: { for: "lenderDocSubmissionDisclaimer" },
                      }),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("label", {
                  staticStyle: { cursor: "pointer" },
                  attrs: { for: "lenderDocSubmissionDisclaimer" },
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("direct-to-lender.lenderSubmit.documentDisclaimer")
                    ),
                  },
                }),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function (ref) {
          var close = ref.close
          return [
            _c(
              "b-row",
              {
                staticClass:
                  "py-3 align-items-center justify-content-between w-100",
              },
              [
                _c(
                  "b-col",
                  { attrs: { cols: "auto" } },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn-sm",
                        attrs: { variant: "white" },
                        on: {
                          click: function ($event) {
                            return _vm.closeModal(close)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("global.words.close")) +
                            "\n        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "auto" } },
                  [
                    _c(
                      "simple-button",
                      {
                        attrs: {
                          disabled: !_vm.canSend,
                          loading: _vm.sendingDocuments,
                          type: "primary btn-sm",
                        },
                        on: { click: _vm.handleSendDocuments },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("documents.sendDocuments")) +
                            "\n        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }